export default function useToggleSmoothScroll() {
  function toggle(enable: boolean) {
    if (enable) {
      setTimeout(() => {
        document.documentElement.classList.add('scroll-smooth');
      }, 0);
    } else {
      document.documentElement.classList.remove('scroll-smooth');
    }
  }

  return toggle;
}
